/// <reference path="../../typings/tsd.d.ts" />

(function () {
    'use strict';

    angular
        .module('SiteRemi')
        .controller('grandprixdepartcguCtrl', grandprixdepartcguCtrl);

    grandprixdepartcguCtrl.$inject = ['$q', 'digiLookUp', '$scope', 'Page'];

    /* @ngInject */
    function grandprixdepartcguCtrl($q, digiLookUp, $scope, Page) {
        /* jshint validthis: true */
        var vm = this;

        Page.setTitle('Grand Prix Départ Chrono Test - Site de Rémi Privet');
        Page.setDescription('Respect de votre vie privée et gestion des données pour l\'application Grand Prix Départ Chrono Test');
        Page.setKeywords('Grand Prix, départ chrono, application, CGU');

    }
})();
